
export {
	_add_to_deps_field,
	addDependencies,
	addDependenciesIfNotExists,
} from '@yarn-tool/pkg-deps-add';
